var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _rect, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLoaderQueencenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-queen-center",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.679,
    height: 62.933,
    viewBox: "0 0 41.679 62.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M25.028,41.495l4.838,2.419,6.463.415,6.082,7.534.415,5.357a115.313,115.313,0,0,1-2.8,19.25s-4.631,11.543-14.9,12.3h-.276c-10.264-.76-14.861-12.3-14.861-12.3a111.365,111.365,0,0,1-2.8-19.25l.553-5.357,5.979-7.5,6.635-.449,4.666-2.419h0m.207-.795h-.38l-.173.1-4.493,2.35-6.5.415-.346.035-.207.276L7.126,51.344l-.138.173-.035.242L6.4,57.116v.138A112.356,112.356,0,0,0,9.234,76.677v.069a26.027,26.027,0,0,0,3.7,6.082c3.318,4.078,7.43,6.394,11.854,6.739h.38c4.424-.311,8.536-2.661,11.854-6.739a26.289,26.289,0,0,0,3.767-6.082l.035-.035v-.035a112.356,112.356,0,0,0,2.834-19.423v-.1l-.415-5.357-.035-.242-.138-.207-6.082-7.5-.242-.276-.346-.035-6.29-.415-4.7-2.35-.173-.069Z",
    transform: "translate(-4.188 -26.634)",
    fill: "#2f292b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M25.041,95.063l-.173-.069c-.622-.207-4.735-.38-6.29-.449h-.1L14.5,90.155,19.753,88.6l4.631,1.21,2.488,2.557Zm-6.324-1c.864.035,4.977.173,6.117.415l1.382-2.039-2.108-2.177-4.355-1.14L15.4,90.432Z",
    transform: "translate(-9.489 -57.98)",
    fill: "#2f292b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M19.938,94.766l-.138-.484a22.086,22.086,0,0,0,3.663-1.348l.069-.035,5.253.726-.069.484-5.08-.726A21.807,21.807,0,0,1,19.938,94.766Z",
    transform: "translate(-12.957 -60.794)",
    fill: "#2f292b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M31.327,97.582A2.625,2.625,0,0,1,28.7,94.955a2.551,2.551,0,0,1,.518-1.555l.38.276a2.1,2.1,0,0,0-.415,1.279,2.143,2.143,0,1,0,4.285,0,3.2,3.2,0,0,0-.138-.795l.449-.173a2.616,2.616,0,0,1-1.486,3.387,2.439,2.439,0,0,1-.968.207Z",
    transform: "translate(-18.781 -61.121)",
    fill: "#2f292b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1.417,
    cy: 1.417,
    r: 1.417,
    transform: "translate(11.128 32.59)",
    fill: "#2f292b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1.417,
    cy: 1.417,
    r: 1.417,
    transform: "translate(27.717 32.59)",
    fill: "#2f292b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M72.2,95.063l-1.8-2.7,2.488-2.557,4.631-1.21,5.253,1.555L78.8,94.544h-.1c-1.521.069-5.633.242-6.29.449Zm-1.175-2.627L72.4,94.475c1.14-.242,5.288-.38,6.117-.415L81.839,90.4,77.45,89.084,73.1,90.224Z",
    transform: "translate(-46.07 -57.98)",
    fill: "#2f292b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M83.682,94.832a22.461,22.461,0,0,1-3.7-1.348l-5.115.726-.069-.484L80.053,93l.069.035a23.288,23.288,0,0,0,3.663,1.348Z",
    transform: "translate(-48.949 -60.86)",
    fill: "#2f292b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M79.327,97.582A2.625,2.625,0,0,1,76.7,94.955a3,3,0,0,1,.173-.968l.449.173a2.028,2.028,0,0,0-.138.795,2.127,2.127,0,0,0,4.251,0,2.172,2.172,0,0,0-.415-1.279l.38-.276a2.6,2.6,0,0,1-.553,3.663A2.318,2.318,0,0,1,79.327,97.582Z",
    transform: "translate(-50.193 -61.121)",
    fill: "#2f292b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M31.468,99.451a2.606,2.606,0,0,1-2.108-.657,1,1,0,0,1-.242-.691l.795-11.612L28.5,84.349l-6.774-2.7L16.5,82.793l-.1-.484,5.357-1.21,7.05,2.8,1.59,2.385L29.567,98.1a.444.444,0,0,0,.138.346c.173.207.622.449,1.728.449s1.555-.242,1.728-.449A.444.444,0,0,0,33.3,98.1v-.035L32.5,86.353l1.59-2.385,7.05-2.8,5.357,1.21-.1.484-5.219-1.175-6.774,2.7-1.417,2.143.795,11.612a.859.859,0,0,1-.242.691A2.649,2.649,0,0,1,31.468,99.451Z",
    transform: "translate(-10.732 -53.072)",
    fill: "#2f292b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M45.7,147.471a9.346,9.346,0,0,1-2.938-.484,11.546,11.546,0,0,1-4.32-2.627l-.242-.242,5.806-2.419,1.693.76,1.693-.76,5.841,2.419-.276.276A10.753,10.753,0,0,1,45.7,147.471Zm-6.635-3.179a11.48,11.48,0,0,0,3.871,2.246c3.249,1.071,6.394.311,9.4-2.281l-4.907-2.039-1.659.76h-.1l-.035-.035-1.59-.726Z",
    transform: "translate(-24.998 -92.729)",
    fill: "#2f292b"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 13.513,
    height: 0.484,
    transform: "translate(13.962 51.286)",
    fill: "#2f292b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M55.207,138.55,55,138.1a3.5,3.5,0,0,0,.276-1.9h.484C55.795,136.822,55.795,138.274,55.207,138.55Z",
    transform: "translate(-35.992 -89.13)",
    fill: "#2f292b"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M63.188,138.55c-.588-.242-.588-1.728-.588-2.35h.484a3.5,3.5,0,0,0,.276,1.9Z",
    transform: "translate(-40.966 -89.13)",
    fill: "#2f292b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M51.032,124.655l-1.728-.449-.1-1.728,1.521-2.177.415.276-1.417,2.039.069,1.21,1.348.346Z",
    transform: "translate(-32.197 -78.725)",
    fill: "#2f292b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M65.238,124.655l-.138-.484,1.382-.346.069-1.21-1.417-2.039.38-.276,1.521,2.177-.1,1.728Z",
    transform: "translate(-42.602 -78.725)",
    fill: "#2f292b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M23.091,127.391l-3.283-3.732-.518-6.912L13,108.729l.138-3.629h.484l-.138,3.491,6.255,7.949.553,6.912,3.179,3.594Z",
    transform: "translate(-8.507 -68.778)",
    fill: "#2f292b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M77.58,127.391l-.38-.346,3.179-3.594.553-6.912,6.255-7.949-.1-3.491h.484l.1,3.629-6.255,8.018-.553,6.912Z",
    transform: "translate(-50.52 -68.778)",
    fill: "#2f292b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M58.327,96.143a1.745,1.745,0,0,0-2.281-.035l-.346-.346a2.238,2.238,0,0,1,2.9-.035Z",
    transform: "translate(-36.45 -62.309)",
    fill: "#2f292b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M56.227,85.912a5.44,5.44,0,0,0-4.977-1.14,5.215,5.215,0,0,0-2,1.106l-.346-.346a5.731,5.731,0,0,1,7.6-.035Z",
    transform: "translate(-32 -55.016)",
    fill: "#2f292b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M52.527,60.879,49.14,59.324l-2.315-7.465L44.3,50.718l-2.488,1.14-2.419,7.465-3.387,1.555L35.8,60.43l3.179-1.452L41.4,51.513,44.267,50.2h.1l.035.035,2.8,1.279,2.315,7.465,3.214,1.452Z",
    transform: "translate(-23.428 -32.851)",
    fill: "#2f292b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M37.808,65.037l-.242-.622,2.074-.795,1.382-11.75L40.5,46.72l-7.569-9.435-6.67-.588-5.426-3.007-5.426,3.179-6.67.415L1.175,46.72.657,51.87,2.039,63.62l2.074.795L3.871,65l-2.454-.933L0,51.87l.553-5.391,7.88-9.815,6.808-.415L20.77,33h.173l.069.035,5.426,3.041,6.808.588,7.88,9.815.553,5.391L40.227,64.1Z",
    transform: "translate(0 -21.595)",
    fill: "#2f292b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M40.51,39.9,40.1,39.42l1.21-1.037-6.324-7.741-7.188-.691L21.952,26.46l-5.875,3.663-7.154.518L2.6,38.383l1.21,1.037-.415.484L1.7,38.452,8.577,30.02,15.9,29.5l6.048-3.8L28,29.329l7.327.691L42.2,38.452Z",
    transform: "translate(-1.112 -16.818)",
    fill: "#2f292b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M40.314,32.424l-.449-.449,1.244-1.21L35.614,24.3l-7.292-.691-6.635-4.285-6.324,4.285-7.6.553L2.264,30.627l1.279,1.348-.484.449L1.4,30.661l6.048-7.119,7.707-.553L21.583,18.6h.207l.1.069,6.67,4.32,7.4.691,6.048,7.154Z",
    transform: "translate(-0.916 -12.172)",
    fill: "#2f292b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M3.059,32.813,1.4,31.016,7.344,24l.518.415-5.6,6.6,1.279,1.348Z",
    transform: "translate(-0.916 -15.706)",
    fill: "#2f292b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M60.2,10.4",
    transform: "translate(-39.395 -6.806)",
    fill: "none",
    stroke: "#2f292b",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M104.969,32.813l-.449-.449,1.244-1.21L100.2,24.415l.484-.415,5.979,7.188Z",
    transform: "translate(-65.571 -15.706)",
    fill: "#2f292b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M10.486,140.68l-3.594-.346-5.391-9.4L4.921,128.1l.415.518-3.007,2.454,4.977,8.64,3.249.311Z",
    transform: "translate(-0.982 -83.829)",
    fill: "#2f292b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M12.308,152.477l-7.292-.587L.8,144.424,2.7,142.8l.415.484-1.486,1.279,3.8,6.7,6.946.588Z",
    transform: "translate(-0.524 -93.449)",
    fill: "#2f292b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M15.246,162.861l-11.508-.829L.8,156.744,2.735,155.5l.346.553-1.417.933,2.454,4.424,11.163.795Z",
    transform: "translate(-0.524 -101.76)",
    fill: "#2f292b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M92.769,140.68l-.069-.657,3.249-.311,4.942-8.64-2.972-2.454.415-.518,3.387,2.834-5.391,9.4Z",
    transform: "translate(-60.663 -83.829)",
    fill: "#2f292b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M86.135,152.477l-.035-.622,6.946-.588,3.767-6.7-1.451-1.279.415-.484,1.866,1.624-4.216,7.465Z",
    transform: "translate(-56.344 -93.449)",
    fill: "#2f292b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M77.735,162.861,77.7,162.2l11.163-.795,2.454-4.424-1.417-.933.346-.553,1.935,1.244-2.938,5.288Z",
    transform: "translate(-50.847 -101.76)",
    fill: "#2f292b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M51.929,172.979h-.173c-1.763-.035-3.007-.415-3.7-1.21a1.867,1.867,0,0,1-.484-1.451v-.035c.138-.622.9-1.659,4.631-1.59,3.249.035,4.113,1.244,4.113,1.866a1.775,1.775,0,0,1-.553,1.382Q54.729,172.979,51.929,172.979Zm-3.871-2.592a1.621,1.621,0,0,0,.38,1.071,4.563,4.563,0,0,0,3.318,1.037c1.8.035,3.076-.276,3.663-.864a1.463,1.463,0,0,0,.415-1.037c0-.276-.622-1.348-3.629-1.382C49.337,169.143,48.2,169.8,48.059,170.387Z",
    transform: "translate(-31.125 -110.392)",
    fill: "#2f292b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M21.787,10.335h4.907l10.264.691,2.9,2.8L42.038,10.4V1.557L32.776,7.95,21.787.9h0L10.8,7.95,1.5,1.557V10.4l2.177,3.283,2.8-2.661,10.713-.691Z",
    transform: "translate(-0.982 -0.589)",
    fill: "#d2c3af"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M39.341,13.72l-3.11-2.972L26.14,10.091h-9.5L6.06,10.783,3.054,13.651.6,9.884V.346l9.608,6.6L21.094,0h.173l.069.069L32.153,6.981,41.8.346V9.884ZM21.2,9.4H26.14l10.368.691,2.7,2.592,1.935-3.007V1.59L32.187,7.741,21.2.691l-10.99,7.05L1.257,1.59V9.711l1.9,2.9,2.592-2.488L16.6,9.435Z",
    transform: "translate(-0.393)",
    fill: "#a68049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoaderQueencenter);
export default __webpack_public_path__ + "static/media/icon-loader-queencenter.3e5787d616bf5d854575adcd358c992e.svg";
export { ForwardRef as ReactComponent };